<template>
    <div>
        <modal ref="modal" @close="goBack()" :content-class="'md:mt-16'">
            <div class="flex flex-col w-full h-full bg-purple-900 p-16 overflow-y-auto">
                <h1 class="font-light mb-5">
                    Depósito / Transferência
                </h1>

                <div class="mt-2 w-full text-center" v-if="planObj">
                    <p class="font-bold">
                        Plano {{ planObj.name }}
                    </p>
                    <p>
                        {{ planObj.price }}
                    </p>
                </div>

                <div v-if="loading" class="flex w-full h-full items-center justify-center">
                    <div class="loader"></div>
                </div>

                <div v-if="!loading">
                    <div class="pl-5 border-l border-white mt-10" v-for="(a, k) in accounts" :key="k">
                        <div class="flex flex-col">
                            <div class="font-bold">
                                {{ a.bank }}
                            </div>

                            <div>
                                <p>
                                    Agência: {{ a.agency }}
                                </p>
                                <p>
                                    Conta: {{ a.account }}
                                </p>
                                <p class="pt-2 italic">
                                    Favorecido <br>
                                    {{ a.owner_name }} <br>
                                    {{ a.document_number }} <br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pt-10">
                    Após realizar a transferência, envie uma foto do comprovante para
                    <a :href="'mailto:' + billing_mail" target="_blank" class="text-blue-300">{{ billing_mail }}</a>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Zapin} from "../../services/Api";

    export default {
        props: {
            plan: String
        },

        mounted() {
            this.$refs.modal.open();

            this.loadPlan();
            this.loadBankAccounts();
        },

        data() {
            return {
                billing_mail: window.appConfig.dash.billing_mail,
                planObj: null,
                loading: false,
                accounts: []
            }
        },

        methods: {
            loadPlan() {
                Zapin
                    .plans()
                    .show(this.plan)
                    .then((res) => {
                        this.planObj = res.data;
                    })
            },

            loadBankAccounts() {
                this.loading = true;

                Zapin
                    .plans()
                    .bankAccounts(this.plan)
                    .then((res) => {
                        this.accounts = res.data;
                    })
                    .finally(() => this.loading = false);
            },

            goBack() {
                history.go(-1);
            }
        }
    }
</script>